import { render } from "./PayrollDetails.vue?vue&type=template&id=d3c56d90&scoped=true"
import script from "./PayrollDetails.vue?vue&type=script&lang=js"
export * from "./PayrollDetails.vue?vue&type=script&lang=js"

import "./PayrollDetails.vue?vue&type=style&index=0&id=d3c56d90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c56d90"]])

export default __exports__